import type { GiftPassBundle } from '@bonsai/shared';

import {
  useRecordEditor,
  type RecordEditor,
  type RecordEditorOptions,
} from '../../shared/editor-page/use-record-editor';

import {
  bundleToForm,
  isBundleFormDirty,
  validateBundleForm,
  type BundleFormErrors,
  type BundleFormValues,
} from './bundle-form';
import { saveErrorToForm } from './save-error';

export type BundleEditorOptions = RecordEditorOptions<BundleFormValues, GiftPassBundle>;
export type BundleEditor = RecordEditor<BundleFormValues, BundleFormErrors>;

const RULES = {
  toForm: bundleToForm,
  validate: validateBundleForm,
  isDirty: isBundleFormDirty,
  saveErrorToForm,
};

export function useBundleEditor(options: BundleEditorOptions): BundleEditor {
  return useRecordEditor(RULES, options);
}
